import { withDependentModelValues } from '../withDependentModelValues';
import { DateElement } from '../DateElement/DateElement';

export const PreferredStartDate = withDependentModelValues(DateElement, [null, { preferredEndDate: 'value' }]);
